//? Library Imports ------------------------------------------------------------>
import { Col, Row, Spin, Space, Input, Typography, Pagination } from "antd";
import debounce from "lodash/debounce";
import { useDispatch } from "react-redux";
import { useRouter } from "next/navigation";
import { useCallback, useEffect, useState } from "react";

//? Assets --------------------------------------------------------------------->

import { ArrowLeftOutlined } from "@ant-design/icons";

//? Modules -------------------------------------------------------------------->
import "../OrdersListingModule/OrdersListingModule.css";
import OrderCard from "./OrderCard/OrderCard";

//? Redux Reducers ------------------------------------------------------------->
import AccountStatus, { customerLogout } from "@/functions/Cookies/Cookies";
import { logoutReducer } from "@/redux/Slices/accountSlice";

//? Library Constants ---------------------------------------------------------->
const { Search } = Input;
const { Text } = Typography;

export default function OrdersListingModule({ setActiveMenu, userAgent }) {
  const { comverse_customer_token } = AccountStatus();

  //? Hooks ---------------------------------------------------------------------->
  const router = useRouter();

  //? Redux States --------------------------------------------------------------->
  const dispatch = useDispatch();
  //? States --------------------------------------------------------------------->
  const [Loading, setLoading] = useState(false);
  const [ActivePage, setActivePage] = useState(1);
  const [CustomerOrders, setCustomerOrders] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [limit, setlimit] = useState(6);

  //? Functions ------------------------------------------------------------------>
  const searchOrders = async (query) => {
    if (comverse_customer_token) {
      try {
        setLoading(true);
        const headers = {
          "Content-Type": "application/json",
        };
        if (comverse_customer_token) {
          headers.Authorization = comverse_customer_token;
        }

        const payload = {
          method: "GET",
          headers: headers,
        };

        const res = await fetch(
          process.env.NEXT_PUBLIC_BACKEND +
          `/storefront/customer_orders?search=${query}`,
          payload
        );

        const data = await res.json();

        if (!res.ok) {
          throw new Error("Orders Search Api Api Failed!");
        }

        setCustomerOrders(data);
        setLoading(false);
        return data;
      } catch (error) {
        console.error("Error fetching data:", error.message);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        return null;
      }
    }
  };

  // const searchQuery = useCallback(debounce(searchOrders, 1000), []);

  const handleSearchValue = debounce((query) => {
    setSearchQuery(query);
  }, 2000);

  const fetchCustomerOrders = useCallback(
    async (page, limitPage) => {
      if (comverse_customer_token) {
        try {
          setLoading(true);
          const headers = {
            "Content-Type": "application/json",
          };
          if (comverse_customer_token) {
            headers.Authorization = comverse_customer_token;
          }

          const payload = {
            method: "GET",
            headers: headers,
          };

          const res = await fetch(
            process.env.NEXT_PUBLIC_BACKEND +
            `/storefront/customer_orders?limit=${limitPage}&page=${page}`,
            payload
          );

          const data = await res.json();

          if (
            data?.detail === "Invalid auth token" ||
            data?.detail === "Session Expired, Please login your account"
          ) {
            // message.error("Session Expired");
            dispatch(logoutReducer());
            customerLogout();
            router.push("/");
          } else if (!res.ok) {
            throw new Error("Customer Orders Api Api Failed!");
          }

          setActivePage(page);
          setCustomerOrders(data);
          setLoading(false);
          return data;
        } catch (error) {
          console.error("Error fetching data:", error.message);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          return null;
        }
      }
    },
    [comverse_customer_token, router, limit]
  );

  //? Life Cycles ---------------------------------------------------------------->
  useEffect(() => {
    if (comverse_customer_token) {
      fetchCustomerOrders(1, limit);
    }
  }, [comverse_customer_token, fetchCustomerOrders]);

  useEffect(() => {
    searchOrders(searchQuery);
  }, [searchQuery]);

  return (
    <Col className="OrdersListingModule padding20">
      <Col span={24} className="">
        <Space size="middle" className="flexBetween width98">
          <Space size="middle">
            <Col
              className="flexCenter cursorPointer"
              onClick={() => setActiveMenu("dashboard")}
              style={{ background: "#FFFFFF", width: "29px", height: "30px" }}
            >
              <ArrowLeftOutlined />
            </Col>
            <Text className="font18">My Orders</Text>
          </Space>

          <Space>
            <Search
              className="searchBar"
              placeholder="Search ..."
              onChange={(e) => {
                handleSearchValue(e.target.value);
              }}
              style={{
                width: 282,
              }}
            />
          </Space>
        </Space>
      </Col>

      {CustomerOrders?.results?.length > 0 ? (
        <>
          <Col span={24} style={{ minHeight: "auto" }}>
            <Spin spinning={Loading} delay={500}>
              {CustomerOrders?.results?.length > 0 ? (
                <Col className="marginTop15">
                  <Row
                    className="gap10"
                    justify="start"
                    style={{ minHeight: "auto" }}
                  >
                    {CustomerOrders?.results?.map((OrderDetail, index) => {
                      const count = (ActivePage - 1) * 6 + index + 1;

                      return (
                        <Col flex="0 0 32%" className="padding0" key={index}>
                          <OrderCard
                            userAgent={userAgent}
                            count={count}
                            OrderDetail={OrderDetail}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              ) : null}
            </Spin>
          </Col>

          <Col className="marginTop20 flexCenter" span={24}>
            <Col span={24} className="backgroundLight flexCenter padding10">
              <Pagination
                pageSizeOptions={[6, 10, 20, 50]}
                pageSize={limit}
                defaultPageSize={6}
                current={ActivePage}
                onChange={fetchCustomerOrders}
                onShowSizeChange={(current, size) => {
                  setlimit(size);
                }}
                total={CustomerOrders?.count}
              />
            </Col>
          </Col>
        </>
      ) : (
        <Col span={24}>
          {CustomerOrders?.results?.length === 0 && (
            <Typography className="no-order-found-text-orders-detail-page">
              No Orders Found
            </Typography>
          )}
        </Col>
      )}
    </Col>
  );
}
